import {
  getPlatformMemberRoles,
  getFactoryRoles,
  getAllFactory,
  getAllSite,
  getProvinces,
  getCityByProIds,
  getCityByProNames,
  getAreaByCityId,
  getStreetByAreaId,
  getAllProductLineList,
  getCategoryByProductLine,
  getCategoryByProductLineName,
  getServiceByType,
  getAllBrand,
  getAllMeetPeople,
  getAllCategory,
  queryConditionSet,
  editHeadSetting,
  getOrderFlag,
  getbuyList,
  getAllLogistics,
  getMessengerMan
} from '@/api/public'

import {
  getFactoryBrand,
  getFactoryProductLine,
  getCategoryByBrandLineName,
  getModelByCondition,
  distinguishModel,
  getByProductLineName
} from '@/api/publicOrder'
import { getList } from '@/api/system/workOrderExpediting/workOrderExpediting'
import {getMeasuresByServiceType} from '@/api/platformOrder/allOrder'
export default {
  data() {
    return {
      serviceMeasuresArr:[], //服务措施
      roleArr: [], //角色
      factoryArr: [], //品牌商
      siteArr: [], //服务商
      provincesArr: [],//省
      cityArr: [], //市
      areaArr: [], //区
      streetArr: [], //街道
      productLineArr: [], //产品线
      productLineCategoryArr: [], //产品线分类
      productLineCategoryNameArr:[], //产品线
      serviceStepArr: [],//服务措施
      brandArr: [],//所有品牌
      meetPeopleArr: [],//对接人
      allCategoryArr: [],//所有品类
      flagsArr: [], //标记类型下拉
      showSetSearchCriteria: false,// 设置搜索条件的弹窗
      queryList: [],// 列表搜索顺序
      leftSearchHeight: 0,
      tableHeight: 0,
      uploading: false,
      tableHeaderDialog: false,// 显示列的弹窗
      showBatchSearch: false,
      pathName: '',
      orderList: [],//列表顺序
      refreshOrder: 0,
      buyChannelArr:[], //购买渠道下拉
      FactoryBrandArr:[], //厂家产品品牌
      factoryProductLineArr:[], //厂家产品线
      categoryByBrandLineArr:[], //厂家产品品类
      modelByConditionArr:[], //根据条件获取产品型号
      urgentArr: [],//加急下拉
      logisticsArr: [], //所有物流下拉
      xinyNameArr:[], //信息员姓名下拉
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    //获取省
    getProvinces(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getProvinces().then(response => {
        if (response.code === 200) {
          this.provincesArr = response.data
          callback()
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取市
    getCityByProIds(ids, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getCityByProIds({
        proIds: ids
      }).then(response => {
        if (response.code === 200) {
          this.cityArr = response.data
          callback()
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取市
    getCityByProNames(names, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getCityByProNames({
        proNames: names
      }).then(response => {
        if (response.code === 200) {
          this.cityArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取区
    getAreaByCity(names, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getAreaByCityId({
        cityName: names
      }).then(response => {
        if (response.code === 200) {
          this.areaArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取街道
    getStreetByArea(names, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getStreetByAreaId({
        areaName: names
      }).then(response => {
        if (response.code === 200) {
          this.streetArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取平台所有角色
    getPlatformRoles(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getPlatformMemberRoles().then(response => {
        if (response.code === 200) {
          this.roleArr = response.data
          callback()
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取厂家所有角色
    getFactoryRoles(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getFactoryRoles().then(response => {
        if (response.code === 200) {
          this.roleArr = response.data
          callback()
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取所有品牌商
    getAllFactory(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getAllFactory().then(response => {
        if (response.code === 200) {
          this.factoryArr = response.data
          callback()
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取所有服务商
    getAllSite(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getAllSite().then(response => {
        if (response.code === 200) {
          this.siteArr = response.data
          callback()
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取所有品牌
    getAllBrandList(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getAllBrand().then(response => {
        if (response.code === 200) {
          this.brandArr = response.data
          callback()
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取所有对接人
    getAllMeetPeopleList(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getAllMeetPeople().then(response => {
        if (response.code === 200) {
          this.meetPeopleArr = response.data
          callback()
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取所有产品线
    getProductLineList(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getAllProductLineList().then(response => {
        if (response.code === 200) {
          this.productLineArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //根据产品线获取产品品类
    getCategoryByProductLine(id, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getCategoryByProductLine(id).then(response => {
        if (response.code === 200) {
          this.productLineCategoryArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //根据产品线名称获取产品品类
    getCategoryByProductNameLine(productLineName, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getCategoryByProductLineName({
        productLineName:productLineName
      }).then(response => {
        if (response.code === 200) {
          this.productLineCategoryNameArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //根据产品线获取产品品类
    getServiceByType(id, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getServiceByType(id).then(response => {
        if (response.code === 200) {
          this.serviceStepArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },

    //获取平台维护的所有品类
    getAllCategory(id, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getAllCategory(id).then(response => {
        if (response.code === 200) {
          this.allCategoryArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取查询条件
    getQueryList(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      queryConditionSet({
        pathName: this.$route.name,
      }).then((res) => {
        if (res.code === 200) {
          this.queryList = res.data;
          this.$nextTick(() => { // 页面渲染完成后的回调
            this.leftSearchHeight = this.$refs.leftSearch.offsetHeight
            this.tableHeight = window.innerHeight - this.$refs.searchBox.offsetHeight - 230
          });
          callback();
        }
      }).catch(err => {
        console.log(err)
      })
    },
    //获取自定义表头
    getQueryOrderList(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      editHeadSetting({
        pathName: this.$route.name,
      }).then((res) => {
        if (res.code === 200) {
          this.orderList = res.data;
          this.refreshOrder++
          callback();
        }
      }).catch(err => {
        console.log(err)
      })
    },
    hideSetSearchCriteria() {
      this.showSetSearchCriteria = false
    },
    // 隐藏显示列
    hideSetTableHeader(data) {
      this.tableHeaderDialog = false
    },
    // 批量搜索
    hideBatchTable(){
      this.showBatchSearch = false
    },
    //获取标记类型下拉
    getOrderFlag(callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getOrderFlag().then(response => {
        if (response.code === 200) {
          this.flagsArr = response.data
          callback()
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取购买渠道
    getbuyList(factoryId,callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getbuyList({
        factoryId: factoryId
      }).then(response => {
        if (response.code === 200) {
          this.buyChannelArr = response.data
          callback()
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取厂家产品品牌
    getFactoryBrand(factoryId, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getFactoryBrand({
        factoryId: factoryId
      }).then(response => {
        if (response.code === 200) {
          this.FactoryBrandArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取厂家产品线
    getFactoryProductLine(obj, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getFactoryProductLine(obj).then(response => {
        if (response.code === 200) {
          this.factoryProductLineArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //根据产品品牌产品线获取产品品类
    getCategoryByBrandLineName(obj, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getCategoryByBrandLineName(obj).then(response => {
        if (response.code === 200) {
          this.categoryByBrandLineArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //根据条件获取产品型号
    getModelByCondition(obj, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getModelByCondition(obj).then(response => {
        if (response.code === 200) {
          this.modelByConditionArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //根据条件获取产品型号
    distinguishModel(obj, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      distinguishModel(obj).then(response => {
        if (response.code === 200) {
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //工单加急下拉
    pubUrgents() {
      getList().then(response => {
        if (response.code === 200) {
          this.urgentArr = response.rows
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //服务要求
    servRequirement(data, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getByProductLineName(data).then(response => {
        if (response.code === 200) {
          callback(response.msg)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //获取服务措施
    getServiceType(params, callback) {
      callback = typeof callback == 'function' ? callback : function() {
      }
      getMeasuresByServiceType(params).then(response => {
        if (response.code === 200) {
          this.serviceMeasuresArr = response.data
          callback(response.data)
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //所有物流名称
    getAllLogistics() {
      getAllLogistics().then(response => {
        if (response.code === 200) {
          this.logisticsArr = response.data
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //信息员名称下拉
    getMessengerMan() {
      getMessengerMan().then(response => {
        if (response.code === 200) {
          this.xinyNameArr = response.data
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    // 更新select
    refreshSelect() {
      this.$forceUpdate()
    }
  }
}
